<template>
  <van-popup v-model="deptUserTreeAll.show" get-container="body" position="bottom">
    <van-nav-bar left-text="取消" right-text="确定" title="选择人员"
                 @click-left="cancel" @click-right="commentPopupSubmit"
    />
    <van-search v-model="deptUserTreeAll.filterText" clearable @clear="clearChange"  shape="round"
                @input="treeSearch($event, $refs.tree)"
    />
    <div class="h-vh-50" style="overflow-y: auto">
      <div class="p-10">
        <el-tree ref="tree" :data="deptUserTreeAll.data" :filter-node-method="filterNode" :props="defaultProps" @node-click="handleNodeClick" />
      </div>
    </div>
  </van-popup>
</template>

<script>
import mixin from "@/mixin/flow";
import {methodGetApi} from "@/api/publicApi";

export default {
  name: "DeptUserTree",
  mixins: [mixin],
  inject: ['feedbackStatisticsProvide'],
  props: {
    deptUserTreeAllShow: {
      type: Boolean,
      default: false
    } ,
    deptBool:{//是否可以选择部门.默认不能选择部门
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 部门用户树
      deptUserTreeAll: {
        show: false,
        data: [],
        filterText: '',
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      treeData: {},
    }
  },
  mounted() {
    this.getDeptUserTreeAll()
  },
  methods: {
    // 人员、部门树
    getDeptUserTreeAll() {
      methodGetApi('/ep/deptTree').then(res => {
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', res.data[0].children)
        })
      })
    },
    handleNodeClick(data) {
      console.log(data)
      console.log(this.deptBool)
      this.$set(this.deptUserTreeAll, 'filterText', data.name)
      this.disabled = !this.deptBool&&data.type == 'user' ? false : true
      // if (data.type == 'user') { // 或其他判断条件
        this.treeData = data;
      // }
      
    },
    clearChange(){
      this.$set(this.deptUserTreeAll, 'filterText', '')
      this.$set(this, 'treeData', {})
      this.$emit('clearDept','')

    },
    commentPopupSubmit() {
      // if (Object.keys(this.treeData).length === 0) {
      //   this.$toast('请选择员工姓名！')
      // } else {
        this.$emit('deptUserTreeSubmit', this.treeData)
        this.deptUserTreeAll.show = false
      // }
    },
    cancel() {
      this.deptUserTreeAll.show = false
    }
  }
}
</script>
